import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/rol';
export const permisosURI = '/usuarios/permisos';

const formatRoles = (data) => {
  if (Array.isArray(data)) {
    return data.map((e) => formatRoles(e));
  }
  return ({
    ...data,
    name: data.name.split(' - ').shift(),
  });
};

/**
 * GET Roles de Usuarios
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRolesDeUsuario = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatRoles(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Rol de Usuario
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getRolDeUsuario = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return formatRoles(response.data);
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Rol de Usuario
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRolDeUsuario = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return formatRoles(response.data);
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Rol de Usuario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRolDeUsuario = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return formatRoles(response.data);
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Rol de Usuario
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteRolDeUsuario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * GET Permisos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPermisosRoles = async (params) => {
  try {
    const response = await API.get(permisosURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
